/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React, { Component, ReactComponentElement } from 'react';

// ours
import { ValueCapsuleViewModel } from 'src/types/view-models/value-capsule.view.model';
import { ValueVariants } from 'src/types/value-variants.enum';
import FormatService from '../../../../services/format.service';

// styles
import styles from './ValueCapsule.module.scss';
import Typography from '../../../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

export default class ValueCapsule extends Component<ValueCapsuleViewModel> {
    public override render(): ReactComponentElement<any> {
        let capsuleStyle: string;
        let typographyStyle: string;
        switch (this.props.amountType) {
            case ValueVariants.POSITIVE:
                capsuleStyle = styles.valuePositive;
                typographyStyle = styles.textPositive;
                break;
            case ValueVariants.NEGATIVE:
                capsuleStyle = styles.valueNegative;
                typographyStyle = styles.textNegative;
                break;
            case ValueVariants.WARNING:
                capsuleStyle = styles.valueWarning;
                typographyStyle = styles.textWarning;
                break;
        }

        let sign: string = '';
        if (this.props.showPositiveSign) {
            sign = '+';
        } else if (this.props.showNegativeSign) {
            sign = '-';
        }

        const value: string = sign + FormatService.format(this.props.amount);

        return (
            <div className={capsuleStyle}>
                <Typography className={typographyStyle} variant={TypographyVariants.HEADING_XS}>
                    {value}
                </Typography>
            </div>
        );
    }
}
